<template>
  <w-icon-wrapper
    :height='24'
    :width='24'
    icon-name='work-demand-icon'
    view-box='0 0 24 24'
  >
    <g
      id="_99_Bedarf_Icon"
      data-name="99 Bedarf_Icon"
      transform="translate(-1068.305 -755.158)"
    >
      <path
        id="Pfad_55789"
        data-name="Pfad 55789"
        d="M40.61.158a12,12,0,1,0,12,12,12,12,0,0,0-12-12m0,22a10,10,0,1,1,10-10,10.011,10.011,0,0,1-10,10"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <path
        id="Pfad_55790"
        data-name="Pfad 55790"
        d="M47.575,16.946v-3.79H33.645v3.79h1.93v-1.79h4.02v1.79h1.93v-1.79h4.12v1.79Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <path
        id="Pfad_55791"
        data-name="Pfad 55791"
        d="M43.61,10.828h-4v-4h4Zm1-5h-6v6h6Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <path
        id="Pfad_55792"
        data-name="Pfad 55792"
        d="M36.374,10.828H34.609V9.063h1.765Zm1-2.764H33.609v3.765h3.765Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4034"
        data-name="Rechteck 4034"
        width="2.006"
        height="2.006"
        transform="translate(1085.303 764.822)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDelete' };
</script>
